import { Injectable, Provider } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ArkikStatusService } from '@core/services/common/arkik-status.service';

@Injectable()
export class JWTInterceptor implements HttpInterceptor {
  constructor(private readonly _arkikStatusServide: ArkikStatusService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const keys = Object.keys(localStorage);
    const tokenKey: string = keys.find((x) =>
      x.includes(environment.B2C_tenantName + '.b2clogin.com' + '-accesstoken'),
    );
    const whiteList: string[] = ['/public', '/EdgeSettings']; //TODO: maybe put this list in a constant
    const isUrlWhileListed: boolean = whiteList.some((item) => request.url.includes(item));

    const tokenLoginOffline = this._arkikStatusServide.getOfflineToken();

    if (environment.isLocalWeb && !request.headers.has('Authorization') && !isUrlWhileListed) {
      if (tokenLoginOffline) {
        const token: { [key: string]: string } = JSON.parse(tokenLoginOffline);

        request = request.clone({
          headers: request.headers.append('Authorization', `Bearer ${token['key'] ?? ''}`),
        });
      }

      if (tokenKey) {
        const token: { [key: string]: string } = JSON.parse(localStorage.getItem(tokenKey));

        request = request.clone({
          headers: request.headers.append('Authorization', `Bearer ${token['secret'] ?? ''}`),
        });
      }
    }

    return next.handle(request);
  }
}

export const JWT_INTERCEPTOR: Provider = {
  provide: HTTP_INTERCEPTORS,
  useClass: JWTInterceptor,
  multi: true,
};
